import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@nextui-org/modal";
import { Button } from "@nextui-org/button";

interface Action {
  label: string;
  color?: string;
  onClick: () => void;
}

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  content: string;
  actions?: Action[];
}

export const CustomModal: React.FC<CustomModalProps> = ({ isOpen, onClose, title, content, actions }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        {title && <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>}
        <ModalBody>
          <p>{content}</p>
        </ModalBody>
        {actions && actions.length > 0 && (
          <ModalFooter>
            {actions.map((action, index) => (
              <Button 
                key={index} 
                color={action.color as "default" | "primary" | "secondary" | "success" | "warning" | "danger" | undefined} 
                onPress={action.onClick}
              >
                {action.label}
              </Button>
            ))}
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};